import { donationUrl } from '@/data/site'

import { ButtonLink } from './ButtonLink'
import { Reveal } from './Reveal'

export function DonationPanel() {
  return (
    <section className="container-wide section-space" aria-labelledby="donation-title">
      <Reveal>
        <div className="donation-panel">
          <div className="donation-panel-content">
            <p className="eyebrow">Hazlo posible</p>
            <h2 id="donation-title">Cada donativo abre oportunidades.</h2>
            <p>
              Terapias, equipo adaptado y acompañamiento empiezan con una comunidad
              que decide estar.
            </p>
            <ButtonLink external href={donationUrl} variant="dark">
              Donar hoy
            </ButtonLink>
          </div>
        </div>
      </Reveal>
    </section>
  )
}
